import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  const preview = faqs.slice(0, 4);

  return (
    <section className="bg-background-100/70">
      <div className="container-x py-12 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-secondary-600">
              <i className="ri-question-line"></i>
              常见问题
            </span>
            <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              你可能想问
            </h2>
          </div>
          <Link
            to="/faq"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
          >
            查看全部问答
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {preview.map((item, idx) => {
            const open = openIdx === idx;
            return (
              <div key={item.q} className="card overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? null : idx)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-3 p-4 text-left"
                >
                  <span className="flex items-center gap-3 text-sm font-semibold text-foreground-900">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xs font-bold text-secondary-700">
                      Q{idx + 1}
                    </span>
                    {item.q}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-400 transition-transform ${open ? "rotate-180" : ""}`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-4 pb-4 pl-14 text-sm leading-6 text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}